export class AcaoAuditoria {

  id: string;
  name: string;

  public static get INSERT() {
    return {id: 'INSERT', name: 'Inclusão'};
  }

  public static get UPDATE() {
    return {id: 'UPDATE', name: 'Atualização'};
  }

  public static get DELETE() {
    return {id: 'DELETE', name: 'Exclusão'};
  }


  public static fromString(name: string){
    const value = (this as any)[name];
    if (value) {
      return value;
    }
    throw new RangeError(
        `Illegal argument passed to fromString(): ${name} does not correspond to any instance of the enum ${
            (this as any).prototype.constructor.name
        }`
    );

  }

  public static get values() {
    return [
      this.INSERT,
      this.UPDATE,
      this.DELETE
    ].sort((a,b) => a.name.localeCompare(b.name));
  }
}
